import vueApp from '../vue-app';
import ElementPlus from 'element-plus';
import 'element-plus/dist/index.css';
import locale from 'element-plus/lib/locale/lang/zh-cn';

vueApp.use(ElementPlus, { locale });
